export default __webpack_public_path__ + "static/our-company-8ced476423d5f0e430cfdb3841c06cd6.png";